import { SubscriptionDescriptionDto } from '@generatedTypes/data-contracts';

export const getDescriptionRows = (description: SubscriptionDescriptionDto | undefined | null) =>
  (description?.bullets ?? []).map((row) => (
    <p className="small" key={row}>
      {row}
    </p>
  ));
